import { Helmet } from 'react-helmet-async'

export const PageTab: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Helmet>
      <title>{text}</title>
    </Helmet>
  )
}
